// @flow

import type { Merchant } from './types';

export function getName(merchant: Merchant): string {
  return merchant.name;
}
